<template>
  <div class="navbar showSmallScreenOnly navbarBackground" :style="navbarStyle">
    <div class="navbar-inner no-swipeback"
      :class="{'navbar-inner-popup': !closePage && closePopup}"
      style="background-color: #00000;" :style="navbarInnerStyle"
      @click="closeCountryPickerModal">

      <!-- Menu "Hamburger" en haut à gauche des écrans de smartphones et tablette -->
      <f7-nav-left>
        <f7-link v-if="!backLink"
          style="color:var(--headbandTextColor)"
          icon-fa="bars" close-picker open-panel="left">
        </f7-link>
        <back-button v-else :backLabel="false" :returnUrl="returnUrl"
          customStyle="color:var(--headbandTextColor);font-size:1.5rem">
        </back-button>
      </f7-nav-left>

      <!-- Logo de MoneyRoad affiché sur écran mobile -->
      <div v-if="!navTitle" class="titleApp centrageLogoSmallScreen">
        <!-- La classe "streammind-icon-popup" est ajoutée s'il s'agit d'une fenêtre pop-up -->
        <p :class="{'streammind-icon-popup': closePopup}" @click="goBackHome()">
          <img :src="imgVarsLong" alt="MoneyRoad" class="heritage">
          <!--<f7-icon class="streammind-icon" v-bind:class="getColor"></f7-icon>-->
        </p>
      </div>
      <!-- Ou titre de la page sur écran mobile -->
      <div v-else style="color:var(--headbandTextColor)">
        <b>{{ navTitle }}</b>
      </div>

      <!-- Bouton cancel pour fermer la fenêtre pop-up, à la fois pour le profile et le service switcher -->
      <div v-if="closePopup && !closePage" class="cancelButton">
        <f7-link class="streammindContactListButton orangeFont" close-popup>{{ $t('common.cncl') }}</f7-link>
      </div>
      <div v-else-if="closePage && !returnPreviousPage">
        <f7-link class="streammindContactListButton cancelButton orangeFont">{{ $t('common.cncl') }}</f7-link>
      </div>
      <div v-else-if="returnPreviousPage">
        <f7-link class="streammindContactListButton cancelButton orangeFont">{{ $t('common.rtrn') }}</f7-link>
      </div>
      <div v-else>
       <div style='min-width:44px;'/>
      </div>

      <!-- Bouton d'ouverture de pop-up de service switch-->
      <!-- <f7-nav-right>
        <f7-link v-if="picker && !closePopup && !closePage && !returnPreviousPage"
          style="color: #051447" close-picker icon-fa="th" open-popup data-popup="#service-switcher-true"></f7-link>
      </f7-nav-right> -->

      <!-- subnavbar des pop-up -->
      <f7-subnavbar v-if="subNavTitle !== '' && !closePage && closePopup"
        :style="'border-bottom-color: ' + color"
        class="subtitle subtitlePopup subnavbarPopup">
        <div v-if="!closePage && closePopup" class="subNavtitlePopup">{{subNavTitle}}</div>
      </f7-subnavbar>

      <!-- subnavbar des fenêtres sauf sur les pop-up -->
      <f7-subnavbar v-else-if="subNavTitle !== ''" :style="'border-bottom-color: ' + color" class="subtitle" >
        <!-- Bouton pour revenir en arrière sur smartphone -->
        <div class="returnButtonMarginLeft">
          <f7-link v-if="ReturnButton" :style="{color: grey}" close-picker>
            <f7-icon f7="play_fill" style="transform: rotate(180deg);"></f7-icon>
          </f7-link>
        </div>
        <div class="subNavtitle">{{subNavTitle}}</div>
        <!-- Bouton d'aide s'il est demandé, sinon il est remplacé par un espace vide -->
        <div v-if="popoverName" class="popoverNamePaddingRight">
          <f7-link class="open-popover"
            :style="{color: grey}"
            href="#"
            :data-popover="popoverName">
            <f7-icon f7="help"></f7-icon>
          </f7-link>
        </div>
        <div v-else>
          <div style="margin-left:15px;"></div>
        </div>
      </f7-subnavbar>
    </div>
  </div>
</template>

<script>
import design from '@/design/design.json'

import backButton from '@/components/common/backButton.vue'

import {errorMessageAlert} from '@/helpers/alert'
import {loadPage} from '@/helpers/routing'

/* Panneau de gauche sur petits écran (smartphones et tablettes) */
export default {
  name: 'MobileHeader',
  components: {
    'back-button': backButton
  },
  props: {
    closePage: {
      type: Boolean,
      default: false
    },
    closePopup: {
      type: Boolean,
      default: false
    },
    currentServiceName: {
      type: String,
      default: ''
    },
    menuAccess: {
      type: Boolean,
      default: false
    },
    navbarStyle: {
      type: String,
      default: ''
    },
    picker: {
      type: Boolean,
      default: true
    },
    popoverName: {
      type: String,
      default: ''
    },
    ReturnButton: {
      type: Boolean,
      default: false
    },
    returnPreviousPage: {
      type: Boolean,
      default: false
    },
    subNavTitle: {
      type: String,
      default: ''
    },
    switchService: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      design: design.menu,
      service: '',
      icon: '',
      backLink: false,
      color: '',
      headerHistory: [],
      navbarInnerStyle: '',
      navTitle: '',
      returnUrl: 'none',
      windowWidth: window.innerWidth
    }
  },
  created () {
    window.addEventListener('resize', this.handleResize)
    this.service = this.$engine.user.currentService.name

    this.icon = this.getIcon(this.service)
    this.color = this.getServiceColor(this.service)
    this.grey = '#404040'
    this.white = '#000000'

    let that = this
    this.$bus.$on('change-mobile-header', function (e) {
      that.backLink = e.backLink
      that.navbarInnerStyle = e.navbarInnerStyle
      that.navTitle = e.navTitle
      that.returnUrl = e.returnUrl
      that.headerHistory.unshift(e)
      if (that.headerHistory.length > 4) {
        that.headerHistory.length = 4
      }
    })
    this.$bus.$on('router-back', function () {
      that.headerHistory.shift()
      let e = that.headerHistory[0]
      that.backLink = e.backLink
      that.navbarInnerStyle = e.navbarInnerStyle
      that.navTitle = e.navTitle
      that.returnUrl = e.returnUrl
    })
    // if (this.windowWidth >= 1024) {
    //   this.updateNotifications()
    // }
  },
  watch: {
  },
  mounted () {
    this.$bus.$on('service:change', (val) => {
      this.service = val
      this.icon = this.getIcon(this.service)
      this.color = this.getServiceColor(this.service)
    })
  },
  computed: {
    imgVarsLong () {
      return this.design.headbandLogoLong
    }
  },
  methods: {
    handleResize () {
      let that = this
      that.windowWidth = window.innerWidth
      that.$bus.emit('window-resize')
    },
    getIcon (service) {
      switch (service) {
        case 'Direct Debit':
          return 'icon-directDebit'
        case 'Payments':
          return 'icon-payments'
        default: // Direct Payments pour la démo
          return 'icon-directPayments'
      }
    },
    getServiceColor (service) {
      switch (service) {
        case 'Direct Debit':
          return '#572B74'
        case 'Payments':
          return '#51A45C'
        default: // Direct Payments pour la démo
          return '#12BCF1'
      }
    },
    closeCountryPickerModal () {
      this.$f7.closeModal('.countryListPicker')
    },
    showProfile () {
      loadPage(this, {url: '/profile/'})
    },
    activateModal () {
      this.$f7.popup('#service-switcher-true')
    },
    goBackHome () {
      var that = this
      loadPage(that, {url: '/home/'})
    },
    /* Ouverture du panneau de gauche (menu hamburger) et ajout des nombres de notifications */
    updateNotifications () {
      let that = this
      /** TLV 24/09/2019
      * Adaptation du modèle appelé en fonction du type de fonctionnalité sur le panneau de gauche
      * Payments --> Appel à payment/isRead
      * Direct Payments --> Appel à directPayment/isRead
      */
      if (this.$engine.user.currentService.name === 'Payments') {
        this.$engine.services.payments.getPaymentsNotReadNumber()
        .then(resp => {
          if (resp.data.requestNotReadNumber > 99) {
            that.Dom7('.numberBadge').text('99+')
          } else {
            that.Dom7('.numberBadge').text(resp.data.requestNotReadNumber)
          }
          /* eslint-disable no-undef */
          // Affichage des notifications sur mobile, provoque une erreur en console sur version web
          if (this.$engine.services.directPayments.filter.smartphoneStorage) {
            // cordova.plugins.notification.badge.set(resp.data.requestNotReadNumber)
          }
          /* eslint-enable no-undef */
        })
        .catch(error => {
          // console.log(error)
          errorMessageAlert(error, that, this.$i18n)
        })
      } else if (this.$engine.user.currentService.name === 'Direct Payments') {
        this.$engine.services.directPayments.getPaymentsNotReadNumber()
        .then(resp => {
          if (resp.data.requestNotReadNumber > 99) {
            that.Dom7('.numberBadge').text('99+')
          } else {
            that.Dom7('.numberBadge').text(resp.data.requestNotReadNumber)
          }
          /* eslint-disable no-undef */
          // Affichage des notifications sur mobile, provoque une erreur en console sur version web
          if (this.$engine.services.directPayments.filter.smartphoneStorage) {
            // cordova.plugins.notification.badge.set(resp.data.requestNotReadNumber)
          }
          /* eslint-enable no-undef */
        })
        .catch(error => {
          // console.log(error)
          errorMessageAlert(error, that, this.$i18n)
        })
      } else if (this.$engine.user.currentService.name === 'Direct Debit') {
        this.$engine.services.directDebit.getPaymentsNotReadNumber()
        .then(resp => {
          if (resp.data.requestNotReadNumber > 99) {
            that.Dom7('.numberBadge').text('99+')
          } else {
            that.Dom7('.numberBadge').text(resp.data.requestNotReadNumber)
          }
          /* eslint-disable no-undef */
          // Affichage des notifications sur mobile, provoque une erreur en console sur version web
          if (this.$engine.services.directPayments.filter.smartphoneStorage) {
            // cordova.plugins.notification.badge.set(resp.data.requestNotReadNumber)
          }
          /* eslint-enable no-undef */
        })
        .catch(error => {
          // console.log(error)
          errorMessageAlert(error, that, this.$i18n)
        })
      }
    },
    /* TLV 09/12/2019
    * Fonction qui redirige l'utilisateur en fonction du service qu'il utilise
    */
    redirectionPage (service) {
      let link = ''

      switch (service) {
        case 'Payments' :
          link = '/dashboard/'
          break
        case 'Direct Payments' :
          link = '/directPayments/inbox/'
          break
        case 'Direct Debit' :
          link = '/directDebit/inbox/'
          break
        default :
          break
      }
      // TLV 25/11/2019 : Bouton de déconnexion depuis la navbar
      if (service === '') {
        this.$bus.emit('logout')
      }
      // Autres boutons de la navbar
      loadPage(this, {url: link})
    }
  }
}
</script>

<style>
.navbarBackground {
  position: absolute;
  align-self: center;
  background-color: var(--headbandColor);
}
.returnButtonMarginLeft {
  margin-left:14px
}
.popoverNamePaddingRight {
  padding-right:6px;
  /* margin-left:15px; */
}
.icon-payments {
  background-image: url('../../assets/static/images/logo/payments.png');
}
.icon-directDebit {
  background-image: url('../../assets/static/images/logo/SEPA.png');
}
/* Direct Payments */
.icon-directPayments {
  background-image: url('../../assets/static/images/logo/exchangeDoc.png');
}
.primary-icon {
  width: 45px;
  height: 45px;
  background-size: contain;
  display: inline-block !important;
  cursor: pointer;
}



/** TLV 25/11/2019
* Le logo de MoneyRoad est petit sur smartphone, grand sur navigateur Web
*/
@media (max-width: 768px) {
  .navbarPopup {
    height: 15%;
    margin-top: -5%;
  }
  .subNavtitle {
      margin-left: 13px;
  }
}
@media (min-width: 768px) and (max-width: 1430px) {
  .navbarPopup {
    height: 21%;
    margin-top: -7%;
  }
}

@media (max-width:768px){
  .subtitlePopup{
    margin-top: -7.5px !important;
  }
}
@media (min-width:768px) AND (max-width:1430px){
  .subtitlePopup{
    /* TLV 27/12/2019 : Remplacement de ce margin de la fenêtre modale sur certaines tailles d'écran
    * pour éviter un bug d'affichage sur la tablette Galaxy S4 */
    margin-top: -42px !important;
  }
}
@media (max-width:991px) {
  .streammind-icon {
    width: 130px;
    height: 60px;
    background-size: contain;
    margin-left: auto;
    margin-right: auto;
  }
}
@media (min-width:992px) {
  .navbar {
     height: 100px;
     position: absolute;
  }
  .streammind-icon {
    width: 400px;
    height: 94px;
    background-size: contain;
    cursor: pointer;
    /* margin-left: 75%; */
  }
}
@media (max-width:1431px) {
  .subtitle {
      margin: -1.35%;
      width: 102%;
  }

  .elsepadding {
    display:none !important;
  }

  .subNavtitlePopup {
    margin-left: 36%;
  }
  .subtitlePopup{
    height: 27px !important;
  }
  .streammind-icon-popup {
    margin-left: 17% !important;

  }

  .navbar-inner-popup {
    height: 96% !important;
    margin-top: 1%;
    margin-bottom: 5%;
  }
}

@media (min-width:1431px) {
  /* TLV 12/12/2019 : la margin passe de -1.35% à -27px sur écran de bureau pour un meilleur affichage des filter */
  .subtitle {
      height: 26.6px;
      margin: -26px -1.35% 0 -1.35%;
      width: 102%;
  }

  .bottomToolbarContainer {
    display:none;
  }

  .subNavtitle {
      margin-left: calc(300px + 3%);
      font-size: 16px;
  }

  /* TLV 27/11/2019 : on supprime le bouton "Back" sur ordi, qui cause des bugs */
  .returnButtonMarginLeft {
   margin-left: -50px;
  }

  /* TLV 28/11/2019 : on supprime le menu hamburger des fenêtres sur grand écran*/
  .fa-bars{
    display:none !important;
  }
  .subNavtitlePopup {
    margin-left: 40%;
  }
  .subtitlePopup{
    /* TLV 26/12/2019 : suppression de cette classe qui cause un problème d'affichage sur écran de tablette */
    /* margin-top: -4.35% !important; */
  }
  .streammind-icon-popup {
    margin-left: auto !important;
  }
}
@media (max-width:991px) {
  .heritage {
    width: 208px;
    background-size: contain;
    margin-left: auto;
    margin-right: auto;
  }
}
@media (min-width:992px) and (max-width:1430px) {
  .heritage {
    width: 489px;
    background-size: contain;
    cursor: pointer;
    /* margin-left: 75%; */
  }
}
/*
.streammind-icon-purple {
  background-image: url('../../assets/static/images/logo/moneyroad_purple.svg');
}
.streammind-icon-green {
  background-image: url('../../assets/static/images/logo/moneyroad_green.svg');
}
.streammind-icon-white-green {
  background-image: url('../../assets/static/images/logo/moneyroad_white_green.png');
}
.streammind-icon-blue {
  background-image: url('../../assets/static/images/logo/moneyroad_blue.svg');
}
.streammind-navicon-moneyroad {
  background-image: url('../../assets/static/images/logo/mrlogo.png');
}
*/
:root {
  --f7-navbar-bg-color: red;
}
</style>



// WEBPACK FOOTER //
// MobileHeader.vue?3769d5da